import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=495d7196&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=495d7196&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495d7196",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('495d7196')) {
      api.createRecord('495d7196', component.options)
    } else {
      api.reload('495d7196', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=495d7196&scoped=true&", function () {
      api.rerender('495d7196', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/inventory/detail.vue"
export default component.exports